var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"graphics-view"},[(_vm.isError)?_c('div',{staticClass:"Error"},[_vm._v("没有获取到相关数据")]):_c('div',{ref:"vegaView"})])
}
var staticRenderFns = []

export { render, staticRenderFns }